document.addEventListener("DOMContentLoaded", function () {
  function updateGallery() {
    // Fetch dropdowns
    const dropdowns = [
      document.querySelector("[name='properties[Insert 1]']"),
      document.querySelector("[name='properties[Insert 2]']"),
      document.querySelector("[name='properties[Insert 3]']"),
      document.querySelector("[name='properties[Insert 4]']")
    ];

    // Grid container and items
    const gridContainer = document.querySelector(".custom-inserts-grid");
    const gridItems = document.querySelectorAll(".custom-insert-item");

    if (!gridItems || gridItems.length === 0) {
      console.warn("No grid items found!");
      return;
    }

    // Collect selected dropdown values
    const selectedValues = dropdowns
      .filter((dropdown) => dropdown) // Ensure dropdown exists
      .map((dropdown) => dropdown.value.trim())
      .filter((value) => value !== ""); // Remove empty values

    console.log("Selected dropdown values:", selectedValues);

    let visibleItemCount = 0;

    // Toggle visibility of grid items
    gridItems.forEach((item) => {
      const productTitle = item.getAttribute("data-product-title")?.trim();

      if (!productTitle) {
        console.warn("Missing 'data-product-title' on grid item!");
        return;
      }

      // Show or hide the item based on matching selected values
      if (selectedValues.includes(productTitle)) {
        item.style.display = "block"; // Show matching item
        const images = item.querySelectorAll(".product-image");
        images.forEach((image) => {
          image.style.display = "block"; // Show associated images
        });
        visibleItemCount++;
      } else {
        item.style.display = "none"; // Hide non-matching items
        const images = item.querySelectorAll(".product-image");
        images.forEach((image) => {
          image.style.display = "none"; // Hide associated images
        });
      }
    });

    // Adjust grid layout based on visible items
    if (gridContainer) {
      gridContainer.classList.remove("single-item", "two-items", "default-layout");

      if (visibleItemCount === 1) {
        gridContainer.classList.add("single-item");
      } else if (visibleItemCount === 2) {
        gridContainer.classList.add("two-items");
      } else if (visibleItemCount > 2) {
        gridContainer.classList.add("default-layout");
      }
    }
  }

  // Attach event listeners to all dropdowns
  const dropdownSelectors = [
    "[name='properties[Insert 1]']",
    "[name='properties[Insert 2]']",
    "[name='properties[Insert 3]']",
    "[name='properties[Insert 4]']"
  ];
  dropdownSelectors.forEach((selector) => {
    const dropdown = document.querySelector(selector);
    if (dropdown) {
      dropdown.addEventListener("change", updateGallery);
    } else {
      console.warn(`Dropdown not found for selector: ${selector}`);
    }
  });

  // Trigger the updateGallery function on page load
  updateGallery();
});

